import LectureLessonLecturerModelBase from '../_generated/modelBases/lecture-lesson-lecturer-model-base';

export default class LectureLessonLecturerModel extends LectureLessonLecturerModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
